import React from 'react'
import './skeleton-partial-calculated-values.css'

export const SkeletonPartialSeatsCalcutatedSelection = () => {
	return (
		<React.Fragment>
			<div className="calculated-values-container">
				<div>
					<span>................</span>
					<span>..................</span>
				</div>
				<div>
					<span>.......................................</span>
					<span>..................</span>
				</div>
				<div>
					<span>..............................</span>
					<span>..................</span>
				</div>
			</div>
			<hr />
			<div className="calculated-values-container">
				<div>
					<span>..........</span>
					<span>..................</span>
				</div>
			</div>
		</React.Fragment>
	)
}
